import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';
import { UnidadeNegocioFormModule } from './form';
import { IntegrationUnidadeNegocioSharedModule } from '../configuracoes/integration/unidade-negocio';
import { ClassificacaoSharedModule } from '../classificacao';
import { UnidadeNegocioNaturezaVendaModule } from './natureza-venda';
import { UnidadeNegocioMercadoModule } from './mercado';

import { UnidadeNegocioRoutingModule } from './unidade-negocio-routing.module';
import { UnidadeNegocioComponent } from './unidade-negocio.component';

@NgModule({
    imports: [
        SharedModule,
        UnidadeNegocioRoutingModule,
        IntegrationUnidadeNegocioSharedModule,
        ClassificacaoSharedModule,
        UnidadeNegocioNaturezaVendaModule,
        UnidadeNegocioMercadoModule,
        UnidadeNegocioFormModule
    ],
    declarations: [
        UnidadeNegocioComponent
    ]
})
export class UnidadeNegocioModule { }
